import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { QuestProvider } from './lib/store.tsx';
import Landing from './pages/Landing.tsx';
import Play from './pages/Play.tsx';
import Reward from './pages/Reward.tsx';

// Staff/admin screens and the dev harness are split out so visitors never download them.
const Redeem = lazy(() => import('./pages/Redeem.tsx'));
const Admin = lazy(() => import('./pages/Admin.tsx'));
const DevPlay = lazy(() => import('./pages/DevPlay.tsx'));
const BoothBoard = lazy(() => import('./pages/BoothBoard.tsx'));
const Duel = lazy(() => import('./pages/Duel.tsx'));

const DEV_HARNESS = import.meta.env.DEV || !!import.meta.env.VITE_DEV_HARNESS;
const home = <Navigate to="/" replace />;

export default function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}

function Shell() {
  const { pathname } = useLocation();
  // The booth TV page renders outside the player store, so it never creates a player session.
  if (pathname === '/leaderboard') {
    return (
      <Suspense fallback={null}>
        <BoothBoard />
      </Suspense>
    );
  }
  // The two-player booth duel also renders outside the player store: each seat gets its own server session instead.
  if (pathname === '/duel') {
    return (
      <Suspense fallback={null}>
        <Duel />
      </Suspense>
    );
  }
  return (
      <QuestProvider>
        <Suspense fallback={<p className="page eyebrow">Loading…</p>}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/play" element={<Play />} />
            <Route path="/reward" element={<Reward />} />
            <Route path="/redeem" element={<Redeem />} />
            <Route path="/admin" element={<Admin />} />
            {/* V1 links (printed QR codes, bookmarks): Landing resumes or starts the one game. */}
            <Route path="/quest" element={home} />
            <Route path="/game/*" element={home} />
            <Route path="/finale" element={home} />
            <Route path="/blueprint" element={home} />
            {DEV_HARNESS ? <Route path="/dev/play/:id" element={<DevPlay />} /> : null}
            <Route path="*" element={home} />
          </Routes>
        </Suspense>
      </QuestProvider>
  );
}
